<template>
  <el-container>
    <div class="container">
      <div>
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" style="width:100%">
          <el-form-item label prop="name">
            <el-input placeholder="请输入姓名" v-model="ruleForm.name" clearable>
              <i slot="prefix" class="el-icon-user"></i>
            </el-input>
          </el-form-item>
          <el-form-item label prop="Mobile">
            <el-input placeholder="请输入手机号" v-model="ruleForm.Mobile" clearable>
              <i slot="prefix" class="el-icon-phone-outline"></i>
            </el-input>
          </el-form-item>
          <el-row>
            <el-col :span="9">
              <el-form-item label prop="verification">
                <el-input v-model.number="ruleForm.verification" placeholder="请输入验证码" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="14" :offset="1">
              <el-button type="primary">
                <span v-show="show" @click="getCode">获取验证码</span>
                <span v-show="!show" class="count">{{count}}s后可重发</span>
              </el-button>
              <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
            </el-col>
          </el-row>
          <br />
          <br />
          <el-form-item style="text-align: center">
            <el-button type="primary" @click="submitForm('ruleForm')" style="width:100%">注册</el-button>
            <el-button @click="login" style="width:100%;margin-top:10px;margin-left:0">已有账号，点击登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </el-container>
</template>

<script>
import wx from "weixin-js-sdk";
import sha1 from "../../assets/sha1";
export default {
  name: "index",
  data() {
    // 验证手机号
    function validateaccount(rule, value, callback) {
      var MobileRegex = /^1[3|4|5|7|8][0-9]\d{8}$/;
      if (!MobileRegex.test(value)) {
        callback(new Error("请输入格式正确的手机号码！"));
      } else {
        callback();
      }
    }
    return {
      // 基础数据
      show: true,
      count: "",
      timer: null,
      parent: {
        height: "600px"
      },
      ruleForm: {
        name: "",
        Mobile: "",
        verification: ""
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        Mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            min: 11,
            max: 11,
            message: "请输入格式正确的手机号码",
            trigger: "blur"
          },
          { validator: validateaccount, trigger: "blur" }
        ],
        verification: [
          // { validator: checkAge, trigger: 'blur' }
          { required: true, message: "请输入验证码", trigger: "blur" }
        ]
      },
      datatime: `${new Date().getFullYear()}-${new Date().getMonth() +
        1}-${new Date().getDate()} ${
        new Date().getHours() < 10
          ? "0" + new Date().getHours()
          : new Date().getHours()
      }:${
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes()
      }:${
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds()
      }`,
      city: "",
      province: "",
      nation: "",
      timestamp: Math.floor(Date.now() / 1000),
      latitude: "",
      longitude: ""
    };
  },
  created() {
    this.sys_click(this.timestamp);
    window.localStorage.setItem(
      "key",
      decodeURIComponent(this.GetQueryString("openid"))
    );
    window.localStorage.setItem(
      "headImageUrl",
      decodeURIComponent(this.GetQueryString("headimgurl"))
    );
    window.localStorage.setItem(
      "city",
      decodeURIComponent(this.GetQueryString("city"))
    );
    window.localStorage.setItem(
      "nickname",
      decodeURIComponent(this.GetQueryString("nickname"))
    );
    window.localStorage.setItem(
      "province",
      decodeURIComponent(this.GetQueryString("province"))
    );
    window.localStorage.setItem(
      "country",
      decodeURIComponent(this.GetQueryString("country"))
    );
  },
  mounted() {},
  methods: {
    getheight() {
      // 获取当前屏幕高度
      this.$data.parent.height =
        (window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight) + "px";
      console.log(this.parent.height);
    },
    getCode() {
      // 验证码倒计时
      this.$http
        .get(
          `/mtscitech/back/frontend/smssendauthcode?phoneNo=${this.ruleForm.Mobile}`
        )
        .then(res => {
          console.log(res);
        });
      console.log("1");
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    submitForm(form) {
      // 获取定位地点
      this.$http
        .get(
          `/mtscitech/back/weixin/getAddressTecent?latitude=${this.latitude}&longitude=${this.longitude}`
        )
        .then(res => {
          this.city = res.data.city;
          this.province = res.data.province;
          this.nation = res.data.nation;
          // 注册
          this.$http
            .post("/mtscitech/back/register/registeruser", {
              authCode: this.ruleForm.verification,
              user: {
                address: "",
                areaName: "",
                cityName: this.city,
                companyName: "",
                country: this.nation,
                gender: true,
                headImageUrl: window.localStorage.getItem("headImageUrl"),
                hideCode: "",
                name: this.ruleForm.name,
                nickname: window.localStorage.getItem("nickname"),
                openid: window.localStorage.getItem("key"),
                ownQrcode: "",
                parentUserPhone: "",
                parentUserUuid: "",
                password: "",
                phone: this.ruleForm.Mobile,
                provinceName: this.province,
                registerTime: this.datatime,
                salesRoom: "",
                state: 2,
                userType: 4,
                userUuid: ""
              },
              userType: 4
            })
            .then(res => {
              console.log(res);
              if (res.message == "注册成功") {
                this.$router.push(
                  `/regcode?openid=${window.localStorage.getItem("key")}`
                );
              } else {
                this.$dialog({
                  title: res.message,
                  lockBgScroll: false,
                  noOkBtn: true,
                  cancelBtnTxt: "我知道了",
                  content: this.GetChinese(res.data)
                });
              }
            });
        });
    },
    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
      var context = "";
      if (r != null) context = r[2];
      reg = null;
      r = null;
      return context == null || context == "" || context == "undefined"
        ? ""
        : context;
    },
    login() {
      this.$router.push("/login");
    },
    //定位获得当前位置信息
    sys_click(time) {
      var that = this;
      this.$http.get("/mtscitech/back/weixin/getJsApiToken").then(res => {
        var token = JSON.parse(res.data);
        var urlcode = window.location.href.split("#")[0];
        var jsapi = `jsapi_ticket=${token.ticket}&noncestr=Wm3WZYTPz0wzccnW&timestamp=${time}&url=${urlcode}`;
        console.log(jsapi);
        var str = sha1(jsapi);
        wx.config({
          debug: false,
          // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: "wxee5337ee015da15d",
          // 必填，公众号的唯一标识
          timestamp: time,
          // 必填，生成签名的时间戳
          nonceStr: "Wm3WZYTPz0wzccnW",
          // 必填，生成签名的随机串
          signature: str,
          // 必填，签名
          jsApiList: ["getLocation"]
          // 必填，需要使用的JS接口列表，所有JS接口列表
        });
      });

      wx.ready(function() {
        wx.checkJsApi({
          jsApiList: ["getLocation"],
          success: function(res) {
            console.log(res);
          }
        });

        wx.getLocation({
          type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: function(res) {
            that.latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
            that.longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
          }
        });
      });

      wx.error(function(res) {
        alert("出错了：" + res.errMsg);
      });
    },
    GetChinese(strValue) {
      // eslint-disable-line
      if (strValue !== null && strValue !== "") {
        const reg = /[\u4e00-\u9fa5]/g;
        return strValue.match(reg).join("");
      }
      return "";
    }
  }
};
</script>

<style  lang="scss">
h2 {
  font-size: rem(18);
}
.home {
  .top {
    color: #fff;
    font-size: rem(16);
    background: url("../../assets/img/bg.png");
    @include bg();
  }
  .box {
    box-sizing: border-box;
    background: #fff;
    border-radius: rem(5);
    margin: rem(15) rem(10) rem(15) rem(10);
    padding: rem(60) rem(10) rem(80) rem(10);
  }
  .lihieght {
    margin: rem(15) rem(0) rem(15) rem(0);
  }
}
#yzm .nut-textinput input {
  width: 150px;
}
</style>